import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        bgdark: '#53565A',
        bglight: '#EEEEEE',
        third: '#007AC3', // BLUE
        second: '#20B457', // GREEN
        first: '#ED1B2E', // RED
      },
    },
  },
});
